import { DetailRows, EditButton, FormSection, ReadOnlyRow } from "./layout";
import { SectionProps, useAccountInfoFields } from "./useAccountInfoFields";

import { InputField } from "../../design-system/input-field";
import { useState } from "react";

/** The clinician's name and phone. A prefilled name starts read-only; the
 * phone is always typed in. */
export const PersonalInfoSection = ({
  prefilled = false,
  ...props
}: SectionProps & { prefilled?: boolean }) => {
  const { errors, textField } = useAccountInfoFields(props);
  // Editable from the start if NPPES left the name empty.
  const [editing, setEditing] = useState(
    !prefilled || !!errors.firstName || !!errors.lastName,
  );

  const nameRows = editing
    ? [
        <InputField
          key="firstName"
          inline
          {...textField("firstName")}
          label="First Name"
          autoComplete="given-name"
        />,
        <InputField
          key="lastName"
          inline
          {...textField("lastName")}
          label="Last Name"
          autoComplete="family-name"
        />,
      ]
    : [
        <ReadOnlyRow
          key="firstName"
          label="First Name"
          value={props.form.firstName}
        />,
        <ReadOnlyRow
          key="lastName"
          label="Last Name"
          value={props.form.lastName}
        />,
      ];

  return (
    <FormSection
      title="Personal Information"
      action={
        !editing && (
          <EditButton
            section="personal information"
            onClick={() => setEditing(true)}
          />
        )
      }
    >
      <DetailRows>
        {nameRows}
        <InputField
          inline
          {...textField("phone")}
          label="Your Phone Number"
          type="tel"
          inputMode="tel"
          autoComplete="tel"
        />
      </DetailRows>
    </FormSection>
  );
};
